import RiskHitFeatureBlock from './RiskHitFeatureBlock';

function formatEnvelopeDate(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('ru-RU', { year: 'numeric', month: 'short', day: 'numeric' });
}

/**
 * Same-size feature strip as the transmission timeline — battery 3.0 V forecast only.
 * Keeps the essential date / horizon; no experiment wall of text.
 */
export default function Risk4ForecastFeature({ projection }) {
  const status = projection?.status;
  const showDate = status === 'crossing_estimated' && projection?.crossing_at;
  const showAlready = status === 'already_below_target';
  const dateLabel = formatEnvelopeDate(projection?.crossing_at);
  const days =
    projection?.days_to_3000 != null && Number.isFinite(Number(projection.days_to_3000))
      ? Math.round(Number(projection.days_to_3000))
      : null;
  const levelNow =
    projection?.envelope_level_now_mv != null &&
    Number.isFinite(Number(projection.envelope_level_now_mv))
      ? Math.round(Number(projection.envelope_level_now_mv))
      : null;

  let headline = 'Дата пока недоступна';
  let sub = 'недостаточно данных для оценки';
  if (showDate && dateLabel) {
    headline = `≈ ${dateLabel}`;
    sub = days != null ? `через ${days} дн.` : 'оценка пересечения 3,0 В';
  } else if (showAlready) {
    headline = 'Уже у порога 3,0 В';
    sub = levelNow != null ? `огибающая ${levelNow} мВ` : 'огибающая на пороге';
  }

  return (
    <RiskHitFeatureBlock title="Прогноз до 3,0 В">
      <div className="flex h-full flex-col items-center justify-center text-center">
        <p className="text-lg font-semibold tabular-nums text-slate-800 dark:text-slate-100">{headline}</p>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">{sub}</p>
        {showDate && levelNow != null ? (
          <p className="mt-2 text-xs tabular-nums text-slate-400">сейчас {levelNow} мВ</p>
        ) : null}
      </div>
    </RiskHitFeatureBlock>
  );
}
